let logger = () => null;

export function reveal() {
  logger(`[reveal] elements ready, revealing the body`);
  window.document.body.removeAttribute('unresolved');
}

export function autoReveal(logFunction) {
  logger = logFunction;
  // If Web Components are already ready, run the handler right away.  If they
  // are not yet ready, wait.
  //
  // see https://github.com/github/webcomponentsjs#webcomponents-loaderjs for
  // info about web component readiness events
  const polyfillPresent = window.WebComponents;
  const polyfillReady = polyfillPresent && window.WebComponents.ready;

  if (!polyfillPresent || polyfillReady) {
    handleWebComponentsReady();
  } else {
    window.addEventListener('WebComponentsReady', handleWebComponentsReady);
  }
}

function handleWebComponentsReady() {
  logger('[reveal] web components ready');
  reveal();
}
